<div class="container">
    <section class="image-grid" *ngFor="let section of gallerySections">
        <h2>{{ section.heading }}</h2>
        <div class="grid">
            <div class="grid-item" *ngFor="let image of section.images">
                <img [src]="image.src" [alt]="image.alt" loading="lazy" (click)="openImageOverlay(image.src)"
                    (contextmenu)="onImageRightClick($event)" />
            </div>
        </div>
    </section>

    <div class="image-overlay" *ngIf="selectedImage" (click)="closeImageOverlay()">
        <img [src]="selectedImage" alt="Enlarged image" (contextmenu)="onImageRightClick($event)" />
        <span class="close-btn" (click)="closeImageOverlay()">&times;</span>
    </div>
</div>